const Loading = () => {
  return (
    <section className="loading">
      <h1>Loading...</h1>;
    </section>
  );
};
export default Loading;
